import React from "react";
import "./Professional.css";
import MenuNavbar from '../function-components/MenuNavbar';
import Floaticons from '../function-components/Floaticons';

function Professional() {
    return (
        <>
            <div className="banner-container">
                <img src="images/Banner1.png" alt="banner" className="banner-img" />
                <MenuNavbar />
            </div>
            <Floaticons />
            <div className="professional-container">

                <h2 className="Industry_head">
                    Professional Skills
                </h2>
                
                {/* <p className="click-here-link">
                    <a href="https://atci.lkm.delivery.accenture.com/ProfessionalSkills/" target="_blank">Click here</a> for more details on Professional Skills
                </p> */}
                <p>
                    Enhancing Professional Skills of employees to showcase improved power skills / inter-personal skills which will help in managing the human side of work well when working with teams.
                    <a href="https://atci.lkm.delivery.accenture.com/ProfessionalSkills/" target="_blank" >Know More</a>
                </p>
            </div>
        </>
    );
}

export default Professional;
